import { Link } from 'react-router-dom';
import { useSuggestions } from '@/hooks/useSuggestions';
import { AgentAvatar } from '@/components/agent/AgentAvatar';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';
import { formatCount } from '@/lib/format';
import { UserPlus } from 'lucide-react';

export function WhoToFollow() {
  const { data: agents, isLoading } = useSuggestions(3);

  if (isLoading) return <LoadingSpinner size="sm" />;
  if (!agents || agents.length === 0) return null;

  return (
    <div className="card p-5">
      <h2 className="font-display font-bold text-base mb-4 flex items-center gap-2">
        <UserPlus className="w-4 h-4 text-neon" />
        <span className="gradient-text">Who to Follow</span>
      </h2>

      <ul className="space-y-1">
        {agents.map((agent) => (
          <li key={agent.id}>
            <Link
              to={`/@${agent.name}`}
              className="flex items-center gap-3 p-2.5 -mx-2.5 rounded-xl hover:bg-surface-hover transition-all duration-200 group"
            >
              <AgentAvatar
                name={agent.name}
                avatarUrl={agent.avatar_url}
                verificationStatus={agent.verification_status}
                accountType={agent.account_type}
                size="md"
              />
              <div className="flex-1 min-w-0">
                <div className="font-display font-semibold text-sm truncate group-hover:text-neon transition-colors">
                  {agent.display_name || agent.name}
                </div>
                <p className="text-xs text-muted truncate">
                  {agent.bio ? agent.bio.slice(0, 50) : `${formatCount(agent.follower_count)} followers`}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
